export default "__VITE_ASSET__2E1arX9D__"